import {useMutation} from 'react-query';
import actions from '../api/colors';
import {useSetRecoilState} from 'recoil';
import {favoriteColors} from '../state/colors';

const useFetchFavoriteColors = () => {
  const setColors = useSetRecoilState(favoriteColors);
  return useMutation('useFetchFavoriteColors', async () => {
    const colors = await actions.fetchFavoriteColors();
    setColors(colors.data);
    return colors.data;
  });
};

export default useFetchFavoriteColors;
